import 'lazysizes';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';

import header from './sections/header';
import listCollections from './templates/list-collections';
import selects from './components/selects'
import pdp from './templates/pdp'
import cart from './templates/cart'
import press from './templates/press'
import faq from './templates/faq'
import newsletter from './components/newsletter'

// init
document.addEventListener('DOMContentLoaded', function() {
    header.init();
    selects.init();
    newsletter.init();
});

setTimeout(() => {
    document.body.classList.remove("overlay-active");
}, 500);

document.addEventListener('DOMContentLoaded', (event) => {
    ((localStorage.getItem('mode') || 'dark') === 'dark') ? document.querySelector('body').classList.add('dark') : document.querySelector('body').classList.remove('dark')
})

switch (document.body.getAttribute("data-template")) {
    case "list-collections":
        listCollections.init();
        break;
    case "product":
        pdp.init();
        break;
    case "cart":
        cart.init();
        break;
    case "page":
        press.init();
        faq.init();
        break;
}